/**
 * ONE rule for "which scroller does a keyboard reveal act on" (KAN-552).
 * Walk up from the field to the first `overflow-y: auto|scroll` ancestor.
 * Inside a modal panel (`[data-cvx-modal-panel]`) the panel itself is a
 * scroller only in curtain mode; reaching it means the field sits OUTSIDE the
 * body scroller (pinned search band):
 *  - panel has an inner scroller → null (the panel must never be scrolled)
 *  - panel has none (hug-content curtain card) → the panel (legacy behaviour)
 * Outside any panel (pages, drawers, sheets) → exactly the plain walk.
 */
export const MODAL_PANEL_ATTR = 'data-cvx-modal-panel';

const isScrollY = (n) => /(auto|scroll)/.test(window.getComputedStyle(n).overflowY);

/** True when `panel` has any descendant that is an overflow-y scroller. */
export function panelHasInnerScroller(panel) {
  if (!panel || typeof panel.querySelectorAll !== 'function') return false;
  return Array.from(panel.querySelectorAll('*')).some(isScrollY);
}

export function revealScrollerFor(el) {
  let n = el ? el.parentElement : null;
  while (n && n !== document.body) {
    if (n.hasAttribute && n.hasAttribute(MODAL_PANEL_ATTR)) {
      return panelHasInnerScroller(n) ? null : n;
    }
    if (isScrollY(n)) return n;
    n = n.parentElement;
  }
  return null;
}

/** True when `el` is inside a modal panel. */
export function isInsideModalPanel(el) {
  return !!(el && typeof el.closest === 'function' && el.closest(`[${MODAL_PANEL_ATTR}]`));
}
